/*
 * Element Brooklyn — mega-menu header behaviour.
 * Vanilla port of the headless React header: mega-menu hover, fragrance hover
 * detail, full-width search takeover (Shopify predictive search), mobile drawer
 * drilldown, country dropdown. Cart opening is left to the existing cart-drawer.js
 * (it auto-binds to #cart-icon-bubble); this only keeps the count in sync.
 */
(function () {
  'use strict';

  var header = document.querySelector('[data-header]');
  if (!header) return;

  var cfgEl = document.querySelector('[data-header-config]');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
  var PREDICTIVE = (cfg.predictiveUrl || '/search/suggest');
  var SEARCH_URL = (cfg.searchUrl || '/search');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ── Menu feature videos: load + play only while their panel is open ──────
     They ship as data-src (see sections/header.liquid) so nothing downloads
     until a shopper actually opens the Shop mega panel or the mobile drawer. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function playVideosIn(container) {
    if (!container) return;
    $all('video[data-src]', container).forEach(function (v) {
      if (!v.getAttribute('src')) {
        v.setAttribute('src', v.getAttribute('data-src'));
        v.preload = reduceMotion ? 'metadata' : 'auto';
      }
      if (!reduceMotion) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    });
  }
  function pauseVideosIn(container) {
    if (!container) return;
    $all('video[data-src]', container).forEach(function (v) { if (!v.paused) v.pause(); });
  }

  /* ── Publish real header height (other sections offset by --header-height) ── */
  function publishHeight() {
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }
  publishHeight();
  // Only republish on WIDTH change — mobile URL-bar show/hide fires resize with a
  // height-only change every scroll frame, which was making the sticky header shake.
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth !== lastW) { lastW = window.innerWidth; publishHeight(); }
  }, { passive: true });

  /* ── Mega menu ──────────────────────────────────────────────────────── */
  var megaContainer = $('[data-mega-container]', header);
  var megaContent = $('[data-mega-content]', header);
  var backdrop = $('[data-mega-backdrop]');
  var navItems = $all('[data-nav]', header);
  var panels = $all('[data-mega-panel]', header);
  var closeTimer = null;

  /* aria-expanded mirrors the .active class on the Shop / Fragrances / Learn
     buttons (each carries aria-controls -> its panel's id in header.liquid), so
     a screen reader hears "expanded" / "collapsed" as the panel opens and
     closes -- on hover, focus or click alike. */
  function openMega(name) {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    megaContainer.classList.add('open');
    header.classList.add('mega-open');
    navItems.forEach(function (b) {
      var on = b.getAttribute('data-nav') === name;
      b.classList.toggle('active', on);
      b.setAttribute('aria-expanded', String(on));
    });
    panels.forEach(function (p) {
      p.hidden = p.getAttribute('data-mega-panel') !== name;
      if (p.hidden) pauseVideosIn(p); else playVideosIn(p);
    });
    if (backdrop) backdrop.hidden = false;
  }
  function closeMega() {
    megaContainer.classList.remove('open');
    header.classList.remove('mega-open');
    navItems.forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-expanded', 'false'); });
    panels.forEach(function (p) { p.hidden = true; pauseVideosIn(p); });
    if (backdrop) backdrop.hidden = true;
    resetFrag();
  }
  function scheduleClose() { closeTimer = setTimeout(closeMega, 100); }
  function cancelClose() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }

  navItems.forEach(function (btn) {
    var name = btn.getAttribute('data-nav');
    btn.addEventListener('mouseenter', function () { openMega(name); });
    btn.addEventListener('focus', function () { openMega(name); });
    btn.addEventListener('click', function () { openMega(name); });
  });
  var navWrap = $('[data-mega-nav]', header);
  if (navWrap) navWrap.addEventListener('mouseleave', scheduleClose);
  if (megaContent) {
    megaContent.addEventListener('mouseenter', cancelClose);
    megaContent.addEventListener('mouseleave', scheduleClose);
  }
  if (backdrop) backdrop.addEventListener('click', closeMega);
  $all('[data-mega-close]', header).forEach(function (l) { l.addEventListener('click', closeMega); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(); });

  /* ── Fragrance hover detail + panel tint ── */
  var fragPanel = $('[data-mega-panel="Fragrances"]', header);
  var fragRight = $('[data-frag-right]', header);
  var fragItems = $all('[data-frag]', header);

  function luminance(hex) {
    var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
    if (!m) return 0.5;
    var r = parseInt(m[1], 16) / 255, g = parseInt(m[2], 16) / 255, b = parseInt(m[3], 16) / 255;
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }
  // Preload + inline the icon SVGs (CORS allows it) so they (a) recolor to the
  // panel's secondary color via currentColor and (b) appear instantly on hover
  // (no image-load flash when moving between fragrances).
  //
  // Deferred to first INTENT (hover/focus of the Fragrances nav item) and only on
  // a desktop-with-hover viewport: running it at script execution fired ~19 SVG
  // requests on every first page view, competing with LCP, and on mobile the mega
  // menu is display:none so they were pure waste. showFrag() still fetches on
  // demand if a hover beats the preload.
  var iconCache = {};
  var iconsPreloaded = false;
  var DESKTOP_HOVER_MQ = window.matchMedia('(min-width: 768px) and (hover: hover)');
  function preloadIcons() {
    if (iconsPreloaded || !DESKTOP_HOVER_MQ.matches) return;
    iconsPreloaded = true;
    fragItems.forEach(function (item) {
      var url = item.getAttribute('data-icon');
      if (!url || url in iconCache) return;
      iconCache[url] = '';
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (txt) {
          if (!txt) return;
          iconCache[url] = txt
            .replace(/fill\s*:\s*#[0-9a-fA-F]{3,6}/g, 'fill:currentColor')
            .replace(/fill="#[0-9a-fA-F]{3,6}"/g, 'fill="currentColor"');
        })
        .catch(function () {});
    });
  }
  var fragNavBtn = $('[data-nav="Fragrances"]', header);
  if (fragNavBtn) {
    fragNavBtn.addEventListener('mouseenter', preloadIcons);
    fragNavBtn.addEventListener('focus', preloadIcons);
  }
  /* Also warm them once the page is idle, so the first hover is usually instant. */
  window.addEventListener('load', function () {
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 2000); };
    idle(preloadIcons);
  });

  function showFrag(item) {
    var color = item.getAttribute('data-color');
    var secondary = item.getAttribute('data-secondary');
    if (!secondary) secondary = luminance(color) > 0.6 ? '#201f1d' : '#fffefb';
    var iconUrl = item.getAttribute('data-icon');
    var subhead = item.getAttribute('data-subhead');
    var mood = item.getAttribute('data-mood');
    if (fragPanel) {
      fragPanel.style.backgroundColor = color;
      fragPanel.style.color = secondary;
      fragPanel.style.setProperty('--frag-text', secondary);
    }
    fragItems.forEach(function (f) { f.classList.toggle('active', f === item); });
    if (fragRight) {
      var svg = iconCache[iconUrl] || '';
      fragRight.innerHTML =
        (svg ? '<span class="mega-frag-product-img">' + svg + '</span>' : '') +
        '<div class="mega-frag-right-copy">' +
        (subhead ? '<h5 class="mega-frag-subhead">' + esc(subhead) + '</h5>' : '') +
        (mood ? '<div class="mega-frag-mood">' + esc(mood) + '</div>' : '') +
        '</div>';
      // Icon not preloaded yet — the preload fetch can lose the race against page
      // load on heavier pages (e.g. Contact, which embeds the contact-form widget),
      // leaving the cache empty when you first hover. Fetch on demand and re-render
      // so the icon always appears instead of silently missing.
      if (!svg && iconUrl) {
        fetch(iconUrl)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (txt) {
            if (!txt) return;
            iconCache[iconUrl] = txt
              .replace(/fill\s*:\s*#[0-9a-fA-F]{3,6}/g, 'fill:currentColor')
              .replace(/fill="#[0-9a-fA-F]{3,6}"/g, 'fill="currentColor"');
            if (item.classList.contains('active')) showFrag(item);
          })
          .catch(function () {});
      }
    }
  }
  function resetFrag() {
    if (fragPanel) { fragPanel.style.backgroundColor = ''; fragPanel.style.color = ''; fragPanel.style.removeProperty('--frag-text'); }
    fragItems.forEach(function (f) { f.classList.remove('active'); });
    if (fragRight) fragRight.innerHTML = '';
  }
  fragItems.forEach(function (item) { item.addEventListener('mouseenter', function () { showFrag(item); }); });
  var quiz = $('.mega-frag-quiz', header);
  if (quiz) quiz.addEventListener('mouseenter', resetFrag);

  /* ── Search takeover ────────────────────────────────────────────────── */

  /* Curated destinations. Shopify only indexes products/pages/articles, so
     everything on an ops subdomain (hospitality. / gallery. / account. / jobs. /
     creators.) and every collection is invisible to search. The table lives in
     snippets/_search-destinations.liquid and arrives through the header config blob.

     ebNorm/ebTier below MUST stay byte-identical to the Liquid matcher in that
     snippet -- the same query has to give the same destinations in this dropdown
     and on /search. The full contract, the keyword policy and the parity matrix
     are documented there; read it before touching either side.

     Keywords arrive PRE-NORMALIZED (lowercase, no punctuation), which is what
     makes the two implementations trivially identical: only the query is
     normalized, and only once. */
  var DESTS = cfg.destinations || [];

  function ebNorm(s) {
    s = String(s == null ? '' : s).toLowerCase();
    s = s.replace(/['’]/g, '');
    /* Same set as the Liquid side; backslash is deliberately excluded. */
    s = s.replace(/[.,?!:;"()\[\]\/_+&*#%@$-]/g, ' ');
    /* Four collapse passes, mirroring Liquid's four chained replaces. */
    s = s.replace(/ {2}/g, ' ').replace(/ {2}/g, ' ').replace(/ {2}/g, ' ').replace(/ {2}/g, ' ');
    return s.trim();
  }

  /* T2 stopwords for single-token queries -- keep identical to stop_pad in
     snippets/_search-destinations.liquid. (1-2 char queries are already
     excluded from T2 by the length guard.) */
  var EB_STOP = ' and the for you your our are can how what where when who why with from this that does not ';

  function ebTier(dest, qpad, qlast, single, t2ok) {
    var kws = String(dest.k || '').split('+');
    var best = 0;
    for (var i = 0; i < kws.length; i++) {
      var kn = kws[i].trim();
      if (kn.length < 3) continue;                                  /* short-keyword noise */
      var kpad = ' ' + kn + ' ';
      if (qpad.indexOf(kpad) !== -1) return 3;                      /* T3 whole word/phrase */
      if (best < 2 && t2ok && kpad.indexOf(qpad) !== -1) best = 2;  /* T2 keyword holds the query */
      /* T1: single-token queries only, and a keyword token must STRICTLY start
         with what was typed. Both guards are load-bearing -- see the T1 note in
         snippets/_search-destinations.liquid for the misfires they fix. */
      if (best < 1 && single && qlast.length >= 4 &&
          kpad.indexOf(' ' + qlast) !== -1 &&
          kpad.indexOf(' ' + qlast + ' ') === -1) best = 1;
    }
    return best;
  }

  function ebMatch(term, cap) {
    var q = ebNorm(term);
    if (!q || !DESTS.length) return [];
    var qpad = ' ' + q + ' ';
    var parts = q.split(' ');
    var qlast = parts[parts.length - 1];
    var single = parts.length === 1;
    var t2ok = q.length >= 3 && !(single && EB_STOP.indexOf(qpad) !== -1);
    /* In T2 and T1, collection rows (c === 'c') go first; T3 (the query holds a
       whole keyword) stays in pure table order, since the phrase hit is the
       specific one ("candle making" -> Workshops before Candles). */
    var b3 = [], b2 = [[], []], b1 = [[], []];
    for (var i = 0; i < DESTS.length; i++) {
      var t = ebTier(DESTS[i], qpad, qlast, single, t2ok);
      var slot = DESTS[i].c === 'c' ? 0 : 1;
      if (t === 3) b3.push(DESTS[i]);
      else if (t === 2) b2[slot].push(DESTS[i]);
      else if (t === 1) b1[slot].push(DESTS[i]);
    }
    /* Stable bucket concatenation -- table order is the editorial tiebreak. */
    return b3.concat(b2[0], b2[1], b1[0], b1[1]).slice(0, cap);
  }

  function ebFeatured() {
    return DESTS.filter(function (d) { return d.f === 'featured'; }).slice(0, 4);
  }

  function ebDestHtml(list) {
    return list.map(function (d) {
      var note = (d.s && d.s !== '-')
        ? '<span class="header-search-item-note">' + esc(d.s) + '</span>'
        : '';
      return '<a href="' + esc(d.u) + '" class="header-search-item header-search-item--dest">' +
        '<span class="header-search-item-subtitle">' + esc(d.t) + '</span>' + note + '</a>';
    }).join('');
  }

  var searchInput = $('[data-search-input]', header);
  var searchResults = $('[data-search-results]', header);
  var searchWrap = $('[data-search-wrap]', header);
  var debounceTimer = null;

  /* There are two search surfaces sharing one renderer: the desktop header
     takeover, and the mobile full-screen panel (sibling of the drawer overlay --
     it cannot live in the header, whose backdrop-filter traps position:fixed).
     A ctx just names which input/results pair a call is operating on. */
  function ctxFor(input, results) { return { input: input, results: results, ctrl: null }; }

  /* Cancel any in-flight predictive request for a surface. Called on every new
     query, on clear and on close, so a slow response can never paint results
     for text that is no longer in the box (or re-open a closed surface). */
  function abortSearch(ctx) {
    if (ctx && ctx.ctrl) { try { ctx.ctrl.abort(); } catch (e) {} ctx.ctrl = null; }
  }
  var deskCtx = ctxFor(searchInput, searchResults);

  var msearch = $('[data-msearch]');
  var msearchInput = msearch ? $('[data-msearch-input]', msearch) : null;
  var msearchResults = msearch ? $('[data-msearch-results]', msearch) : null;
  var msearchDefault = msearch ? $('[data-msearch-default]', msearch) : null;
  var msearchCtx = ctxFor(msearchInput, msearchResults);
  var msearchTimer = null;
  var msearchScrollY = 0;
  var MOBILE_SEARCH_MQ = window.matchMedia('(max-width: 767px)');

  function openSearch() {
    abortSearch(deskCtx);
    if (searchInput) searchInput.value = '';
    if (searchResults) { searchResults.hidden = true; searchResults.innerHTML = ''; }
    header.classList.add('search-open');
    closeMega();
    /* The mobile trigger lives in the drawer, which is a full-screen overlay --
       leave it up and the takeover renders behind it. closeDrawer() also releases
       the body scroll-lock it set. Hoisted, so calling it from up here is fine;
       it no-ops when there's no drawer. */
    closeDrawer();
    setTimeout(function () { if (searchInput) searchInput.focus({ preventScroll: true }); }, 60);
  }
  function closeSearch() {
    clearTimeout(debounceTimer);
    abortSearch(deskCtx);
    header.classList.remove('search-open');
    if (searchInput) searchInput.value = '';
    if (searchResults) { searchResults.hidden = true; searchResults.innerHTML = ''; }
  }
  /* Resting state: bestsellers grid visible, no results. */
  function resetMobileSearch() {
    clearTimeout(msearchTimer);
    abortSearch(msearchCtx);
    if (msearchResults) { msearchResults.hidden = true; msearchResults.innerHTML = ''; }
    if (msearchDefault) msearchDefault.hidden = false;
  }
  function openMobileSearch() {
    if (!msearch) return;
    closeMega();
    /* Drop the drawer first -- it is a full-screen overlay and also owns a body
       scroll-lock we are about to re-take. While that lock is on the document is
       clamped to scrollY 0, so the real position is the drawer's savedScrollY,
       not window.scrollY. */
    var drawerWasOpen = overlay && overlay.classList.contains('open');
    var y = drawerWasOpen ? savedScrollY : (window.scrollY || window.pageYOffset || 0);
    closeDrawer();
    msearchScrollY = y;
    resetMobileSearch();
    if (msearchInput) msearchInput.value = '';
    msearch.hidden = false;
    document.body.classList.add('eb-no-scroll');
    document.body.style.top = -msearchScrollY + 'px';
    if (msearchInput) {
      /* Reflow so the field is laid out, then focus SYNCHRONOUSLY -- iOS only
         raises the keyboard for a focus() in the same task as the user's tap,
         so this must not be deferred to a timeout. */
      void msearch.offsetHeight;
      msearchInput.focus({ preventScroll: true });
    }
  }
  function closeMobileSearch() {
    if (!msearch || msearch.hidden) return;
    msearch.hidden = true;
    document.body.classList.remove('eb-no-scroll');
    document.body.style.top = '';
    restoreScroll(msearchScrollY);
    if (msearchInput) msearchInput.value = '';
    resetMobileSearch();
  }

  /* One trigger attribute, routed by viewport. The desktop magnifier is
     .header-desktop-only and the drawer entry only exists on mobile, so in
     practice this maps 1:1 to which button was tapped -- but routing on the
     media query keeps a resized window honest.

     DOCUMENT scope, not `header`: the mobile trigger sits in the drawer overlay,
     which is a SIBLING of <header data-header>, not a descendant. Scoped to the
     header this binds only the desktop magnifier and mobile search silently dies. */
  function openSearchAuto() {
    if (MOBILE_SEARCH_MQ.matches && msearch) openMobileSearch();
    else openSearch();
  }
  $all('[data-search-open]').forEach(function (b) { b.addEventListener('click', openSearchAuto); });
  $all('[data-msearch-close]').forEach(function (b) { b.addEventListener('click', closeMobileSearch); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMobileSearch();
  });
  $all('[data-search-close]', header).forEach(function (b) { b.addEventListener('click', closeSearch); });

  /* Page hits to keep out of the dropdown (kiosk/debug pages everywhere, US-only
     pages outside the US). Rules: HIDDEN PAGES in snippets/_search-destinations.liquid,
     which also filters /search. Shopify has no per-page search exclusion short of
     seo.hidden / unpublishing, so this is the backstop. */
  var HIDE = cfg.hidePages || {};
  function pageHidden(pg) {
    var h = (pg && pg.handle) || '';
    if (!h && pg && pg.url) h = String(pg.url).split('?')[0].split('/').pop();
    if (!h) return false;
    if ((HIDE.exact || []).indexOf(h) !== -1) return true;
    if (HIDE.prefix && h.indexOf(HIDE.prefix) === 0) return (HIDE.allow || []).indexOf(h) === -1;
    return false;
  }
  /* Path only: predictive URLs carry _pos/_psq/_ss tracking params, destination
     URLs are bare (and may be absolute), so a raw string compare never matched. */
  function urlPath(u) {
    u = String(u || '').split('?')[0].split('#')[0];
    return u.replace(/^https?:\/\/[^\/]+/, '').replace(/\/$/, '') || '/';
  }
  /* Shopify CDN images accept a width param; the predictive JSON returns the
     2000px original for a 60px slot. */
  function cdnWidth(u, w) {
    if (!u || u.indexOf('cdn.shopify.com') === -1 && u.indexOf('/cdn/shop/') === -1) return u;
    var base = u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function renderResults(data, term, ctx) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = (r.products || []).slice(0, 3);
    var pages = (r.pages || []).filter(function (pg) { return !pageHidden(pg); }).slice(0, 3);
    var queries = (r.queries || []).slice(0, 3);
    var dests = ebMatch(term, 3);

    /* Total miss. Previously a dead end with two hardcoded suggestions; now it
       offers the `featured` destinations, which is at least navigation. */
    if (!products.length && !pages.length && !queries.length && !dests.length) {
      var fallback = ebFeatured();
      ctx.results.innerHTML =
        '<div class="header-search-empty">No Results for <span>' + esc(term) + '</span></div>' +
        (fallback.length
          ? '<div class="search-group"><p class="header-search-section-label">TRY THESE</p>' +
            ebDestHtml(fallback) + '</div>'
          : '');
      ctx.results.hidden = false;
      return;
    }

    var html = '';
    if (products.length) {
      html += '<div><p class="header-search-section-label">PRODUCTS</p><div class="header-search-products-scroll">';
      products.forEach(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        /* alt="" -- the title is the adjacent link text, so repeating it is noise. */
        html += '<a href="' + esc(p.url) + '" class="header-search-item">' +
          (img ? '<div class="header-search-item-img"><img src="' + esc(cdnWidth(img, 120)) + '" srcset="' +
            esc(cdnWidth(img, 120)) + ' 1x, ' + esc(cdnWidth(img, 240)) + ' 2x" width="60" height="60" alt="" loading="lazy"></div>' : '') +
          '<div class="header-search-item-info"><span class="header-search-item-title">' + esc(p.title) + '</span></div></a>';
      });
      html += '</div>';
      /* "View all results": the dropdown keeps only 3 products, and Enter was the
         only way on to the full results page -- invisible on touch, where the
         mobile panel's keyboard "search" key is easy to miss. Same URL the Enter
         handlers below build (SEARCH_URL is routes.search_url, so it carries the
         market prefix: /en-gb/search, /en-au/search). Sits OUTSIDE the products
         scroll box so it never scrolls out of view, and only renders with product
         hits (the no-product branch below has nothing more to show). Reuses the
         destination-row classes: --dest drops the subtitle's capitalize, so the
         label keeps its authored casing. renderResults() serves both the desktop
         takeover and the mobile [data-msearch] panel, so both get the link. */
      html += '<a href="' + esc(SEARCH_URL + '?q=' + encodeURIComponent(term)) + '" class="header-search-item header-search-item--dest">' +
        '<span class="header-search-item-subtitle">View all results</span></a>';
      html += '</div>';
    } else {
      /* No products but something curated matched -- "track my order", "wholesale",
         "workshop". This is the case the old dropdown handled worst. */
      html += '<div class="header-search-empty">No product results for <span>' + esc(term) + '</span></div>';
    }

    html += '<div class="header-search-grid search-group">';

    /* Curated first, then Shopify's own page hits, deduped by URL, combined cap 5.
       They share one column on purpose: curated destinations ARE pages
       semantically, and .header-search-grid is repeat(2, 1fr) at >=1024px, so a
       third group would orphan a cell. */
    var destUrls = dests.map(function (d) { return urlPath(d.u); });
    var extraPages = pages.filter(function (pg) { return destUrls.indexOf(urlPath(pg.url)) === -1; })
                          .slice(0, Math.max(0, 5 - dests.length));
    if (dests.length || extraPages.length) {
      html += '<div><p class="header-search-section-label">PAGES</p>' + ebDestHtml(dests);
      extraPages.forEach(function (pg) {
        html += '<a href="' + esc(pg.url) + '" class="header-search-item"><span class="header-search-item-subtitle">' + esc(pg.title) + '</span></a>';
      });
      html += '</div>';
    }

    if (queries.length) {
      html += '<div><p class="header-search-section-label">SUGGESTIONS</p>';
      queries.forEach(function (q) {
        html += '<button class="header-search-item" data-suggestion="' + esc(q.text) + '"><span class="header-search-item-subtitle">' + esc(q.text) + '</span></button>';
      });
      html += '</div>';
    }
    html += '</div>';

    ctx.results.innerHTML = html;
    bindSuggestions(ctx);
    ctx.results.hidden = false;
  }

  function bindSuggestions(ctx) {
    $all('[data-suggestion]', ctx.results).forEach(function (b) {
      b.addEventListener('click', function () {
        ctx.input.value = b.getAttribute('data-suggestion');
        ctx.input.focus();
        runSearch(ctx.input.value, ctx);
      });
    });
  }

  function runSearch(q, ctx) {
    if (!ctx || !ctx.results) return;
    abortSearch(ctx);
    if (!q) { ctx.results.hidden = true; return; }
    /* limit_scope=each: without it the limit is shared across all three types
       (Shopify's default `all`), which left the dropdown with 2 products. */
    var url = PREDICTIVE + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,page,query&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last';
    var ctrl = window.AbortController ? new AbortController() : null;
    ctx.ctrl = ctrl;
    fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        /* Stale guard (also covers browsers without AbortController): drop the
           response unless it is still this surface's live request, the box still
           holds this query, and the surface is still open. */
        if (!data || ctx.ctrl !== ctrl) return;
        if (!ctx.input || ctx.input.value.trim() !== q) return;
        if (ctx === deskCtx && !header.classList.contains('search-open')) return;
        if (ctx === msearchCtx && (!msearch || msearch.hidden)) return;
        ctx.ctrl = null;
        renderResults(data, q, ctx);
      })
      .catch(function () {});
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { runSearch(q, deskCtx); }, 180);
    });
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = searchInput.value.trim();
        if (q) window.location.href = SEARCH_URL + '?q=' + encodeURIComponent(q);
      }
    });
  }
  document.addEventListener('mousedown', function (e) {
    if (header.classList.contains('search-open') && searchWrap && !searchWrap.contains(e.target)) {
      if (searchResults) searchResults.hidden = true;
    }
  });

  if (msearchInput) {
    msearchInput.addEventListener('input', function () {
      var q = msearchInput.value.trim();
      clearTimeout(msearchTimer);
      /* Empty field returns to the bestsellers grid rather than a blank screen. */
      if (!q) { resetMobileSearch(); return; }
      if (msearchDefault) msearchDefault.hidden = true;
      msearchTimer = setTimeout(function () { runSearch(q, msearchCtx); }, 180);
    });
    msearchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = msearchInput.value.trim();
        if (q) window.location.href = SEARCH_URL + '?q=' + encodeURIComponent(q);
      }
    });
  }

  /* ── Mobile drawer ──────────────────────────────────────────────────── */
  var overlay = $('[data-drawer-overlay]');
  var drawerPanels = overlay ? $all('[data-eb-panel]', overlay) : [];
  var drawerToggle = $('[data-drawer-toggle]');
  var mobileBurger = $('[data-mobile-burger]');
  var mobileBack = $('[data-mobile-back]');
  var currentPanel = 'main';

  // The single top-left control morphs: hamburger (closed) → X (main menu) →
  // back arrow (submenu). Only ever one of them is shown.
  function updateControl() {
    var open = overlay && overlay.classList.contains('open');
    var inSubmenu = open && currentPanel !== 'main';
    if (mobileBurger) {
      mobileBurger.hidden = inSubmenu;
      mobileBurger.classList.toggle('active', open && !inSubmenu);
    }
    if (mobileBack) mobileBack.hidden = !inSubmenu;
    if (drawerToggle) drawerToggle.setAttribute('aria-expanded', String(!!open));
  }
  function showPanel(name) {
    currentPanel = name;
    var drawerOpen = overlay && overlay.classList.contains('open');
    drawerPanels.forEach(function (p) {
      p.hidden = p.getAttribute('data-eb-panel') !== name;
      if (p.hidden || !drawerOpen) pauseVideosIn(p); else playVideosIn(p);
    });
    updateControl();
  }
  var savedScrollY = 0;
  /* Scroll-lock restore. MUST be instant: html has scroll-behavior:smooth
     (critical CSS), and the lock clamps the document to 0, so a plain
     scrollTo(0, y) visibly animated from the top on every dismiss. */
  function restoreScroll(y) {
    try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); }
    catch (e) { window.scrollTo(0, y); }
  }
  /* ── Drawer as a modal dialog: focus in, Tab contained, page behind inert ──
     The drawer covers the page (role="dialog" aria-modal="true" in header.liquid),
     so keyboard and screen-reader users must not wander behind it. Its close /
     back control is NOT inside it, though: the header hamburger
     (data-drawer-toggle) stays on top and morphs into the X / back arrow, and the
     in-panel .eb-m-back buttons are display:none. So the Tab loop is
     [toggle] + whatever is rendered in the drawer, and the header is never made
     inert. (Screen readers that honour aria-modal can't reach the toggle, so the
     drawer also carries a visually-hidden "Close menu" button, tabindex -1 so the
     Tab loop skips it.)

     What goes inert is the page behind: main content, the footer group, the
     other header-group sections (the announcement bar), the PDP breadcrumbs and
     the skip link. Deliberately NOT body-wide: the cart drawer (the header's cart
     icon still opens it over the menu) and the global modals (the drawer's
     currency button opens the country shelf, and RegularModal's click handler
     runs before ours and focuses into it) must stay live. */
  var drawerEl = overlay ? $('[data-drawer]', overlay) : null;
  var DRAWER_BEHIND = '#MainContent, body > .breadcrumbs, .skip-to-content-link, ' +
    '.shopify-section-group-header-group, .shopify-section-group-footer-group';
  var DRAWER_FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
    'select:not([disabled]), textarea:not([disabled]), [tabindex]';
  var drawerReturnFocus = null;
  var drawerInert = [];

  /* Rendered = has a box. Hidden panels ([hidden] -> display:none) and the
     display:none .eb-m-back buttons drop out; so does the toggle on desktop. */
  function isRendered(el) { return !!(el && el.getClientRects().length); }
  function drawerFocusables() {
    var list = drawerEl ? $all(DRAWER_FOCUSABLE, drawerEl).filter(function (el) {
      return el.tabIndex >= 0 && isRendered(el);
    }) : [];
    if (isRendered(drawerToggle)) list.unshift(drawerToggle);
    return list;
  }
  /* Focus that belongs to the drawer: inside it, on its toggle, or dropped on
     <body>. Anything else (the cart drawer opened over the menu, a modal) owns
     its own Tab / Escape, so the handlers below leave it alone. */
  function inDrawerScope(el) {
    return !el || el === document.body || el === drawerToggle || !!(drawerEl && drawerEl.contains(el));
  }
  /* Only ever un-inert what we inerted, so an element something else made inert
     is left as it was. */
  function setBackgroundInert(on) {
    if (on) {
      $all(DRAWER_BEHIND).forEach(function (el) {
        if (el.contains(overlay) || el.hasAttribute('inert')) return;
        el.setAttribute('inert', '');
        drawerInert.push(el);
      });
    } else {
      drawerInert.forEach(function (el) { el.removeAttribute('inert'); });
      drawerInert = [];
    }
  }
  /* First control of the visible panel (never the toggle -- focus is moving IN). */
  function focusDrawerStart() {
    var first = drawerFocusables().filter(function (el) { return el !== drawerToggle; })[0];
    if (first) first.focus({ preventScroll: true });
  }

  function openDrawer() {
    if (!overlay) return;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    /* The toggle is the only opener; Safari doesn't focus a tapped button, so
       activeElement is <body> there and we fall back to the toggle. */
    var active = document.activeElement;
    drawerReturnFocus = (active && active !== document.body) ? active : drawerToggle;
    overlay.classList.add('open');
    document.body.classList.add('eb-no-scroll');
    document.body.style.top = -savedScrollY + 'px';
    setBackgroundInert(true);
    showPanel('main');
    focusDrawerStart();
    // Re-assert the control state after the scroll-lock layout shift so the
    // close X reliably renders (guards against a missed repaint on mobile).
    requestAnimationFrame(updateControl);
  }
  function closeDrawer() {
    if (!overlay) return;
    /* openSearch()/openMobileSearch() call this unconditionally; only undo the
       lock (and restore scroll) if the drawer actually held it, or opening the
       desktop search would jump the page to savedScrollY (0 on first use).
       Every close path (toggle X, Escape, backdrop tap, the hidden close button,
       search, the currency shelf) comes through here, so the inert and focus
       teardown lives here too. */
    var wasOpen = overlay.classList.contains('open');
    overlay.classList.remove('open');
    if (wasOpen) {
      document.body.classList.remove('eb-no-scroll');
      document.body.style.top = '';
      restoreScroll(savedScrollY);
      setBackgroundInert(false);
      /* Return focus to the opener -- but only if focus is still the drawer's.
         Mobile search and the country shelf move focus themselves (the shelf has
         already done so by the time we run), and must not have it pulled back. */
      if (drawerReturnFocus && inDrawerScope(document.activeElement) && document.contains(drawerReturnFocus)) {
        drawerReturnFocus.focus({ preventScroll: true });
      }
      drawerReturnFocus = null;
    }
    showPanel('main');
  }
  function controlClick() {
    var open = overlay && overlay.classList.contains('open');
    if (!open) openDrawer();
    else if (currentPanel === 'main') closeDrawer();
    else showPanel('main');
  }
  if (drawerToggle) drawerToggle.addEventListener('click', controlClick);
  $all('[data-drawer-close]', overlay || document).forEach(function (b) {
    b.addEventListener('click', closeDrawer);
  });
  /* Escape closes (from any panel) and hands focus back; Tab / Shift+Tab cycle
     through [toggle] + the visible panel's controls. Handled on every Tab rather
     than only at the ends because the toggle sits in the header, so DOM order
     would otherwise walk through the logo and cart before reaching the drawer. */
  if (overlay) {
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('open')) return;
      if (e.key !== 'Escape' && e.key !== 'Tab') return;
      if (!inDrawerScope(document.activeElement)) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      var items = drawerFocusables();
      if (!items.length) return;
      var i = items.indexOf(document.activeElement);
      var next;
      if (i === -1) next = e.shiftKey ? items[items.length - 1] : items[0];
      else next = items[(i + (e.shiftKey ? items.length - 1 : 1)) % items.length];
      e.preventDefault();
      next.focus();
    });
  }
  $all('[data-eb-go]', overlay || document).forEach(function (b) {
    b.addEventListener('click', function () {
      showPanel(b.getAttribute('data-eb-go'));
      /* The button just pressed now sits in a hidden panel, so focus would drop
         to <body>; move it to the first control of the submenu that opened. */
      focusDrawerStart();
    });
  });
  $all('[data-eb-back]', overlay || document).forEach(function (b) {
    b.addEventListener('click', function () { showPanel('main'); });
  });
  if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) closeDrawer(); });

  // Currency switch inside the drawer opens the footer's country/region shelf
  // (a .js-country-region-trigger RegularModal). Close the drawer first so the
  // shelf isn't stuck behind it; the modal's own global handler still fires on
  // the same click (we don't stop propagation).
  $all('.js-country-region-trigger', overlay || document).forEach(function (b) {
    b.addEventListener('click', closeDrawer);
  });

  /* ── Country selector dropdowns ── */
  $all('[data-eb-country]').forEach(function (root) {
    var toggle = $('[data-eb-country-toggle]', root);
    var menu = $('[data-eb-country-menu]', root);
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = menu.hidden;
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) { menu.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
    });
    /* Escape closes the list and returns focus to its button. stopPropagation
       keeps the document-level Escape from also closing the whole mega panel. */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) {
        e.stopPropagation();
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  });

  /* ── Cart count live-sync (drawer handles open/close itself) ── */
  function setCount(n) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !(n > 0);
    });
  }
  /* PUB_SUB_EVENTS is a top-level `const` (constants.js) and so is NOT on
     window — reference the globals directly. Both load deferred in <head>,
     ahead of this section script. No /cart.js fallback: publishers that don't
     send a count have already swapped the cart-icon-bubble section, which
     server-renders [data-cart-count]. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var data = event && event.cartData;
      var count = data && (data.item_count != null ? data.item_count : data.itemCount);
      if (count != null) setCount(count);
    });
  }
})();
